module.exports = function getResource (label, vars = []) {
    let resources = {
        orderTotal: 'Order Total',
        merchandiseSubtotal: 'Merchandise Subtotal',
        giftCardShipping: 'Gift Card Shipping',
        merchandiseShipping: 'Merchandise Shipping',
        shippingAndHandling: 'Shipping & Handling',
        discounts: 'Discounts',
        giftWrap: 'Gift Wrap',
        gstHst: 'GST/HST',
        pst: 'PST',
        tax: 'Tax',
        storeCreditRedeemed: 'Account Credit',
        giftCardRedeemed: 'Gift Card Redeemed',
        eGiftCardRedeemed: 'eGift Card Redeemed',
        creditCardPayment: 'Credit Card Payment',
        payPalPayment: 'PayPal Payment',
        includesTaxVat: 'includes taxes and VAT',
        submitEdits: 'Submit Edits',
        subscribe: 'Subscribe',
        placeOrder: 'Place Order',
        shippingHandling: 'Shipping & Handling',
        pickupText: 'Pickup',
        free: 'FREE',
        shippingHandlingInfo: 'Shipping & Handling Information',
        salesTax: 'Sales Tax',
        pointsUsed: 'Used',
        bagFee: 'Bag Fee',
        specialFee: 'Special Fee',
        pointsAfterPickup: 'You will earn Beauty Insider points from this purchase after you pick up the order.',
        gotIt: 'Got It'
    };
    return resources[label] || label;
};
